import React from "react";

import { MenuBtnStyled } from "./menuBtn.styles";

const MenuBtn = ({ title }) => {
  return <MenuBtnStyled>{title}</MenuBtnStyled>;
};

export default MenuBtn;
